import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgPin2 = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill='#fff'
      fillRule='evenodd'
      d='M12 5.5c-.988 0-1.912.248-2.582.918S8.5 8.013 8.5 9s.248 1.912.918 2.582 1.595.918 2.582.918c.988 0 1.912-.248 2.582-.918S15.5 9.987 15.5 9s-.248-1.912-.918-2.582S12.988 5.5 12 5.5M10.5 9c0-.68.17-1.005.332-1.168.163-.163.489-.332 1.168-.332.68 0 1.005.17 1.168.332.163.163.332.489.332 1.168 0 .68-.17 1.005-.332 1.168-.163.163-.489.332-1.168.332-.68 0-1.005-.17-1.168-.332-.163-.163-.332-.489-.332-1.168'
      clipRule='evenodd'
    />
    <path
      fill='#fff'
      fillRule='evenodd'
      d='M12 1C8.19 1 5.867 2.522 4.543 4.508 3.264 6.426 3 8.65 3 10c0 3.495 1.46 6.338 3.23 8.475 1.764 2.13 3.87 3.604 5.28 4.397a1 1 0 0 0 .98 0c1.41-.793 3.516-2.266 5.28-4.397C19.54 16.338 21 13.495 21 10c0-1.349-.264-3.574-1.543-5.492C18.133 2.522 15.81 1 12 1m-7 9c0-1.151.236-2.926 1.207-4.383C7.133 4.228 8.809 3 12 3c3.19 0 4.867 1.228 5.793 2.617C18.764 7.074 19 8.85 19 10c0 2.905-1.207 5.312-2.77 7.2-1.376 1.661-3.003 2.887-4.23 3.64-1.227-.753-2.854-1.979-4.23-3.64C6.207 15.312 5 12.905 5 10'
      clipRule='evenodd'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgPin2)
export default ForwardRef
